import React from 'react';
import ContentContainer from '../ContentContainer/ContentContainer';
import ProfileColumns from '../ProfileColumns/ProfileColumns';
import styles from './PortalUserProfileForm.module.css';

interface PortalUserProfileLayoutProps {
  onSubmit: (event: React.FormEvent) => void;
  leftColumn: React.ReactNode;
  rightColumn: React.ReactNode;
  actions: React.ReactNode;
  contentClassName?: string;
  withContentContainer?: boolean;
}

export const PortalUserProfileLayout: React.FC<PortalUserProfileLayoutProps> = ({
  onSubmit,
  leftColumn,
  rightColumn,
  actions,
  contentClassName,
  withContentContainer = true,
}) => {
  const content = (
    <form onSubmit={onSubmit} noValidate>
      <ProfileColumns>
        <div className={styles.columnLeft}>{leftColumn}</div>
        <div className={styles.columnRight}>{rightColumn}</div>
      </ProfileColumns>
      <div className={styles.actions}>{actions}</div>
    </form>
  );

  if (!withContentContainer) {
    return (
      <div className={`${styles.embedded} ${contentClassName ?? ''}`.trim()}>
        {content}
      </div>
    );
  }

  return (
    <ContentContainer className={`${styles.content} ${contentClassName ?? ''}`.trim()}>
      {content}
    </ContentContainer>
  );
};

interface PortalUserProfileLeftHeaderProps {
  title?: string;
  subtitle?: string;
}

export const PortalUserProfileLeftHeader: React.FC<PortalUserProfileLeftHeaderProps> = ({
  title = 'Dados de acesso',
  subtitle = 'Foto e informações vinculadas ao login',
}) => (
  <div>
    <h2 className={styles.columnTitle}>{title}</h2>
    <p className={styles.columnSubtitle}>{subtitle}</p>
  </div>
);

interface PortalUserProfileMetaSectionProps {
  label: string;
  children: React.ReactNode;
}

export const PortalUserProfileMetaSection: React.FC<PortalUserProfileMetaSectionProps> = ({
  label,
  children,
}) => (
  <div className={styles.metaSection}>
    <span className={styles.metaLabel}>{label}</span>
    <div className={styles.metaContent}>{children}</div>
  </div>
);

export const PortalUserProfileMetaValue: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <span className={styles.metaValue}>{children}</span>
);
